import { normalize } from 'styled-normalize';
import { createGlobalStyle } from 'styled-components';

import { getBrandColor } from './lib/utils';

export const theme = {
  colors: {
    a: '#000', // black
    b: '#fff', // white
    c: '#f2f2f2', // grey
    d: '#dfdfdf', // grey
    e: '#424242', // grey
    f: '#757575', // grey
    g: '#9e9e9e', // grey
    h: '#bdbdbd', // grey
    brand: getBrandColor(), // dynamic brand color
    success: '#287233', // green
    error: '#ff0033', // red
  },
  fonts: {
    body: `-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif`,
    headings: `'Roboto Condensed', sans-serif`,
  },
  layers: {
    header: 900,
  },
  breakpoints: {
    small: '480px', // min-width: 480px	Mobile-landscape (and larger)
    medium: '768px', // min-width: 768px Tablet-portrait (and larger)
    large: '992px', // min-width: 992px	Tablet-landscape (and larger)
    xlarge: '1200px', // min-width: 1200px Laptops (and larger)
    xxlarge: '1600px', // min-width: 1600px The whole Universe (and larger)
  },
  sizes: {
    headerHeight: 52,
    edgeSpacing: 20,
    phi: 1.61803398875,
  },
};

export const GlobalStyles = createGlobalStyle`
  ${normalize}

  html {
    color: ${theme.colors.a};
    font-family: ${theme.fonts.body};
    font-size: 1em;
    font-weight: 400;
    line-height: ${theme.sizes.phi};
    background-color: ${theme.colors.b};
  }

  html, body {
    height: 100%;
  }

  #root {
    height: 100%;
  }
`;
